@if (
  {
    selectedPayment: selectedPayment$ | async,
    paymentModes: paymentModes$ | async,
    bankCards: bankCards$ | async,
    isLoggedIn: isLoggedIn$ | async,
    sbrfPaymentMode: sbrfPaymentMode$ | async,
    activePaymentCode: activePaymentCode$ | async,
    timeSlotsIsEmpty: timeSlotsIsEmpty$ | async,
  };
  as obs
) {
  @if (!obs.timeSlotsIsEmpty) {
    <div class="payment-variants_wrapper">
      <div class="payment-variants">
        @if (obs.sbrfPaymentMode?.hasBindings) {
          <div class="bankCards">
            @for (bankCard of obs.bankCards; track bankCard) {
              <sd-radio
                class="payment-variant"
                [class.active]="activeRadioPayment === PaymentModeCodes.Sbrf + ':' + bankCard.bindingId"
                name="payment-variant"
                [value]="PaymentModeCodes.Sbrf + ':' + bankCard.bindingId"
                [(ngModel)]="activeRadioPayment"
                (ngModelChange)="setActivePayment(PaymentModeCodes.Sbrf, bankCard)"
              >
                <div class="payment-variant-content">
                  <span class="name">**** {{ bankCard.lastNumbers }}</span>
                  <cx-icon [type]="iconType.CREDIT_CARD"></cx-icon>
                </div>
              </sd-radio>
            }
          </div>
        }

        @if (obs.isLoggedIn && obs.sbrfPaymentMode?.hasBindings) {
          <sd-radio
            class="payment-variant"
            [class.active]="activeRadioPayment === 'paymentBinding'"
            name="payment-variant"
            value="paymentBinding"
            [(ngModel)]="activeRadioPayment"
            (ngModelChange)="goToPaymentBinding()"
          >
            <div class="payment-variant-content">
              <span class="name">Новой картой</span>
              <cx-icon [type]="iconType.CARD_PLUS"></cx-icon>
            </div>
          </sd-radio>
        }

        @if (obs.paymentModes) {
          @for (mode of obs.paymentModes; track mode) {
            @if (mode.code !== PaymentModeCodes.Sbrf || !obs.isLoggedIn || !obs.sbrfPaymentMode?.hasBindings) {
              <sd-radio
                [class.active]="activeRadioPayment === mode.code"
                class="payment-variant"
                name="payment-variant"
                [value]="mode.code"
                [(ngModel)]="activeRadioPayment"
                (ngModelChange)="setActivePayment(mode.code)"
              >
                <div class="payment-variant-content">
                  <span class="name">{{ mode.name }}</span>
                  <cx-icon [type]="variantIcon[mode.code] ?? iconType.CREDIT_CARD"></cx-icon>
                </div>
              </sd-radio>
            }
          }
        } @else {
          <div class="payment-variants">
            <div class="skelet"></div>
            <div class="skelet"></div>
            <div class="skelet"></div>
            <div class="skelet"></div>
          </div>
        }
      </div>

      @if (activeRadioPayment === PaymentModeCodes.Plait) {
        <sd-payment-schedule></sd-payment-schedule>
      }
    </div>
  }
}
